<div adaptToolbarContent>
    <div [adaptTooltip]="hasChanges ? 'Please save or discard your changes first' : undefined">
        <button class="ms-2"
                adaptButton="add"
                [disabled]="progressProducts.length === 0 || hasChanges"
                [adaptBlockingClick]="addProductsToOrganisation">journey progress to organisation</button>
    </div>
    <button adaptButtonIcon="add"
            [adaptBlockingClick]="createNewProgressProduct">Add new journey progress module</button>
</div>

<dx-sortable handle=".product-card-drag-handle"
             [data]="progressProducts"
             [moveItemOnDrop]="true"
             [allowReordering]="true"
             (onReorder)="onProductReorder($event)">
    @for (product of progressProducts; track product.progressProductId) {
        <div class="card card-info"
             [attr.data-progress-product-id]="product.progressProductId">
            <div class="card-header">
                <h2 class="card-title d-flex gap-2 align-items-center">
                    <div class="product-card-drag-handle dx-list-item-after-bag dx-list-reorder-handle-container">
                        <div class="dx-list-reorder-handle"></div>
                    </div>
                    <div>
                        {{ product.name }} (code <code>{{ product.code ?? "N/A" }}</code>)
                    </div>
                </h2>
                <div class="card-header-buttons p-2"
                     adaptBlockingButtonGroup>
                    <button adaptButton="add"
                            [adaptBlockingClick]="createNewProgressCategory"
                            [adaptBlockingClickParam]="product">new category</button>
                    <button adaptButton="edit"
                            [adaptBlockingClick]="editProgressProduct"
                            [adaptBlockingClickParam]="product">journey progress module</button>
                    <button adaptButton="delete"
                            [adaptBlockingClick]="deleteProduct"
                            [adaptBlockingClickParam]="product"
                            [unsubscribeOnDestroy]="false">journey progress module</button>
                </div>
            </div>
            <div class="card-body">
                <dx-sortable class="d-flex flex-column gap-3"
                             handle=".card-drag-handle"
                             [data]="product.progressCategories"
                             [moveItemOnDrop]="true"
                             [allowReordering]="true"
                             (onReorder)="onCategoryReorder($event, product)">
                    @for (category of product.progressCategories; track category.progressCategoryId) {
                        <adapt-edit-progress-category class="bg-body-tertiary rounded-2"
                                                      [category]="category"
                                                      [attr.data-progress-category-id]="category.progressCategoryId"
                                                      [autoSave]="false"
                                                      [canEdit]="true"
                                                      [canEditProduct]="true"
                                                      (categoryEdit)="editProgressCategory(category).subscribe()"
                                                      (categoryDelete)="deleteCategory(category).subscribe()"></adapt-edit-progress-category>
                    } @empty {
                        <p class="m-0 text-muted">No categories defined yet.</p>
                    }
                </dx-sortable>
            </div>
        </div>
    }
</dx-sortable>
